export default {
  props: {
    title: String,
    default: "卡片标题"
  },
  data: function data() {
    return {
      isClose: true
    };
  }
};